<template>
  <div class="slide-content-placeholder">
    <component
      class="flex vertical layout slide-content--wrapper animate__animated"
      id="slide-content--wrapper"
      :class="{
        'contentFadeInLeft': $store.state.transitionContent == 'left',
        'contentFadeInRight': $store.state.transitionContent == 'right'
      }"
      :is="SlideContentComponents[slideActive.type]"
      :slideActive="slideActive"
      :presentation="presentation"
    />
  </div>
</template>

<script>
import SlideContentComponents from './SlideContentComponents.js'

export default {
  name: 'ExtensibleSlideContent',
  props: {
    slideActive: {
      type: Object,
      required: true,
    },
    presentation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      SlideContentComponents,
    }
  },
  computed: {
    // Computed properties go here
  },
  methods: {
    // Component methods go here
  },
}
</script>

<style lang="scss" scoped>
.slide-content-placeholder {
  height: 100%;
  width: 100%;
  flex: 1;
}
.slide-content--wrapper {
  width: 100%;
  height: 100%;

  &.animate__animated {
    animation-duration: 0.3s;

    &.contentFadeInLeft {
      animation: contentFadeInLeft cubic-bezier(0.25, 1, 0.5, 1) .3s;
    }

    &.contentFadeInRight {
      animation: contentFadeInRight cubic-bezier(0.25, 1, 0.5, 1) .3s;
    }
  }

  &::v-deep.audio-title-slide ::v-deep {
    audio {
      position: relative;
      z-index: 1;
    }
  }
}
</style>
